import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { DynamicFieldsService } from '../dynamic-fields.service';
import * as _ from 'lodash';

@Component({
    selector: 'dynfield-radio',
    template: require('./dynamic-fields.radio.component.html')
})
export class DynamicFieldRadioComponent implements OnInit, OnChanges {
    @Input() version: any;
    @Input() field: any;
    @Input() fieldsOptions: any;
    @Input() fieldError: any;
    @Input() allowUpdate: any;

    isRequired: boolean;
    error: any;

    constructor(private dynamicFieldsService: DynamicFieldsService) {}

    ngOnInit() {
        this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
        this.isRequired = this.dynamicFieldsService.isRequired(this);
        this.setDefaultValue();
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.fieldError) {
            this.error = this.dynamicFieldsService.setError(
                changes.fieldError?.currentValue, this.field
            );
        }
    }

    private setDefaultValue() {
        if (_.isEmpty(this.field.fieldData) && this.field.alias !== '') {
            const el = _.find(this.fieldsOptions[this.field.alias].fieldElements, { defaultSelected: true });
            if (el) {
                this.field.fieldData = { id: el.id };
            } else {
                this.field.fieldData = { id: null };
            }
        }
    }
}
